import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import ModalConfirm from '../../utils/form/modalConfirmBase';
import { Tooltip, Switch, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { permissionsConstans } from "../../constansPermissions";
import { updateStatusRol } from '../../actions/role-actions';

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnEvent: {
    paddingLeft: "20px",
    margin: 'auto 2%',
    // flexBasis: "10%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },

}));

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.white,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: 'green',
        borderColor:  'green',
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.white}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:  theme.palette.secondary.main,
  },
  checked: {},
}))(Switch);

export default function DetailedAccordion({
  headers,
  data,
  openModuleEvent,
  resetData,
  permissionsRoles,
  onEdit,
  onDelete,
  onApprove,
  onPublish,
  onClose,
  onReject,
  showEdit,
  showDelete,
}) {

  const classes = useStyles();
  const id = IdKey.generate();

  const [checked, setChecked] = React.useState(false);
  const [open, setOpen] = useState(false)
  const [idChecked, setIdChecked] = useState();
  const [message, setMessage] = useState({
    description : '',
    textButtonSubmit : '',
    handleClick : () => {} ,
    handleClickOut : () => {},
    oneButtons : false,
    type : '',
    open : false
  });

  const validationPermissionEdit = () => {
    if(permissionsRoles?.functionalities?.some((x)=> x === permissionsConstans.ROL_EDITAR)){
       return <Tooltip title={data?.status?.toUpperCase() === "ACTIVO" ? "Inactivar" : 'Activar'} arrow placement="top">
                <AntSwitch
                  checked={data.status === "Activo" ? true : false}
                  onClick={(event) =>  { event.stopPropagation();  toggleChecked(data)}}
                  onFocus={(event) => event.stopPropagation()}
                />
              </Tooltip>
     }
  }

  const toggleChecked = (data) => {
      setMessage({
        description : data?.status?.toUpperCase() === 'ACTIVO' ? '¿Está seguro que desea inactivar el rol?' : '¿Está seguro que desea activar el rol?',
        textButtonSubmit : 'Aceptar',
        handleClick : () => changeStatusRol(data, data?.status),
        handleClickOut: () => handleClickOut(),
        type : 'QUESTION' ,
        open : true
    });
  };

  const handleClickOut = () => { setMessage({...message, open: false});};
  const handleClick = () => {
    setMessage({...message, open: false});  setChecked((prev) => !prev);
    resetData();
  };

  const changeStatusRol = async (data, status) => {
    const jsonStatusRol = {id: data.id, status: status === "Activo" ? "INACTIVO" : "ACTIVO"  }
    const response = await updateStatusRol(jsonStatusRol);
    if(response?.status >= 200 && response?.status < 399 ){
      setMessage({
        description : data?.status?.toUpperCase() === 'ACTIVO' ? `Rol inactivado exitosamente` : `Rol activado exitosamente`,
        textButtonSubmit : 'Aceptar',
        handleClick : () => handleClick(),
        type : 'SUCCESS',
        oneButtons: true,
        open : true
      });
    } else if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
      setMessage({
          description : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
          textButtonSubmit : 'ACEPTAR',
          handleClick : () => handleClickOut() ,
          oneButtons : true,
          type : 'WARNING',
          open : true
      })
    } else {
      setMessage({
          description : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
          textButtonSubmit : 'ACEPTAR',
          handleClick : () => handleClickOut() ,
          oneButtons : true,
          type : 'WARNING',
          open : true
      })
    }
  };

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      return object[header.field] !== null ? object[header.field] : "";
    }
    return object[header.field] !== null
    ? object[header.field]
    : "";
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
        <ModalConfirm
          description = { message.description }
          textButtonSubmit = { message.textButtonSubmit }
          handleClick = { message.handleClick }
          handleClickOut = { message.handleClickOut }
          oneButtons = { message.oneButtons }
          type = { message.type }
          open = { message.open }
        />
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
          borderLeftStyle: 'solid',
          borderLeftColor: '#F8DF13',
        }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column} stye = {{  backgroundColor: checked ? 'gray' : null }}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          <div className={classes.columnEvent}>
          {validationPermissionEdit()}

          </div>
          <Button
             onClick={(event) =>  { event.stopPropagation(); openModuleEvent({...data}, true)}}
             onFocus={(event) => event.stopPropagation()}
            className = {classes.buttonSearch}>Asignar Módulos</Button>
        </FlippedOrderExpansionPanelSummary>
      </Accordion>
    </div>
  );
}
